module.exports = __webpack_public_path__ + "static/Green-Olives-Stuffed-With-Fetta-Cheese-834c02749bbd50093e1e094dad3a17da.png";